import React from 'react'
import { useDispatch } from 'react-redux'

import { enableInsuranceAction } from 'src/effects/Availability/actions'
import { routes } from 'src/constants/routes'

import OfferConditions from './OfferConditions'

import styles from './styles.module.css'
import InsuranceSelector from './InsuranceSelector'
import OfferResponsivePriceAndButtons from './OfferResponsivePriceAndButton'
import Affiliate from 'src/comps/Affiliate'
import { useBusiness } from 'src/hooks/useBusiness'

interface OfferResponsiveProps {
  board: any
  isLoading?: boolean
  isMultiRoom: boolean
  isSelected: boolean
  nights: number
  onClick: (arg: any) => void
  prime?: boolean
  showAffiliate: boolean
  showMore?: JSX.Element
  bestPrice?: boolean
}

const OfferResponsive = ({
  board,
  isLoading = false,
  isMultiRoom,
  isSelected,
  nights,
  onClick,
  prime = false,
  showAffiliate,
  showMore,
  bestPrice = false,
}: OfferResponsiveProps) => {
  const pageId = routes.detail.page
  const dispatch = useDispatch()

  const { affiliate } = useBusiness()

  const handleClickBook = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()

    if (!isLoading) {
      onClick({ board, isRemove: isSelected })
    }
  }

  const handleClickInsurance = (isEnable: boolean) => {
    dispatch(
      enableInsuranceAction({
        availabilityId: board.availabilityId,
        insuranceSelected: isEnable,
      })
    )
  }

  return (
    <>
      {showAffiliate ? (
        <Affiliate className={styles.redesignAffiliateContainer} id={affiliate} />
      ) : null}
      <div className={styles.boardContainer}>
        <OfferConditions
          code={board.code}
          cancellation={board.cancellation}
          currency={board.currency}
          name={board.boardName}
          paymentPolicy={board.paymentPolicy}
          payRate={board.payRate}
          isMobile={board.isMobile}
          bestPrice={bestPrice}
        />
        {board.insurance && (
          <InsuranceSelector
            {...board.insurance}
            isSelected={board.insuranceSelected}
            onClick={handleClickInsurance}
            consumer={pageId}
          />
        )}
      </div>
      <OfferResponsivePriceAndButtons
        board={board}
        isLoading={isLoading}
        isMultiRoom={isMultiRoom}
        isSelected={isSelected}
        nights={nights}
        onClick={handleClickBook}
        prime={prime}
        showMore={showMore}
      />
    </>
  )
}

export default OfferResponsive
